import Logger from "../../logger";
import LandmarkHelper from "../helper";

/**
 * CursorInfo-Landmark. Will be triggered once per session.
 * @param {HTMLElement} element Element which posesses this landmark.
 * @param {object} data Landmark configuration data. Cannot be null.
 * @param {function} sendLandmark Function to send data to the landmark service. Cannot be null.
 */

let sendLandmarkFunction;

const landmarkData = {};
const CURSOR_INFO_LANDMARKED = 'cursorInfoLandmarked';
const CURSOR_INFO_VALUE = 'cursorValue';

export default function (element, data, sendLandmark) {
    Object.assign(landmarkData, data);
    sendLandmarkFunction = sendLandmark;

    window.addEventListener('mousemove', sendMouseCursorLandmark);
    window.addEventListener('touchstart', sendTouchCursorLandmark);
}

function sendMouseCursorLandmark() {
    sendCursorLandmark('mouse');
}

function sendTouchCursorLandmark() {
    sendCursorLandmark('touch');
}

function sendCursorLandmark(type) {
    const landmarkedSessionId = localStorage.getItem(CURSOR_INFO_LANDMARKED) ? localStorage.getItem(CURSOR_INFO_LANDMARKED).toString() : null;
    const sessionIdentifier = LandmarkHelper.getSessionId() ? LandmarkHelper.getSessionId().toString() : null;

    if (sessionIdentifier && (landmarkedSessionId !== sessionIdentifier)) {
        landmarkData.cursor = type;
        landmarkData.landmark = 'action';
        sendLandmarkFunction(landmarkData);

        try {
            localStorage.setItem(CURSOR_INFO_LANDMARKED, sessionIdentifier);
        } catch (e) {
            Logger.debug(`[LANDMARK] LocalStorage cannot be set for CursorInfoLandmark ${e}`);
        }
    }

    if (!localStorage.getItem(CURSOR_INFO_VALUE)) {
        try {
            localStorage.setItem(CURSOR_INFO_VALUE, type);
        } catch (e) {
            Logger.debug(`[LANDMARK] LocalStorage cannot be set for CursorInfoValue ${e}`);
        }
    }

    // Remove event binding so that it's only triggered once
    window.removeEventListener('mousemove', sendMouseCursorLandmark);
    window.removeEventListener('touchstart', sendTouchCursorLandmark);
}
